import { IonIcon } from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 16px;
`

export const Icon = styled(IonIcon)`
  color: ${myPalette.black.main};
  width: 28px;
  height: 28px;
`

export const Divider = styled.div`
  width: 1px;
  align-self: stretch;
  background: ${myPalette.black.main};
`

export const Title = styled.span`
  color: ${myPalette.black.main};
  font-size: 18px;
  font-weight: 700;
`
